import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';
export class TdConfirmDialogComponent {
  title: string;
  message: string;
  cancelButton: string = 'CANCEL';
  acceptButton: string = 'ACCEPT';
/**
 * @param {?} _dialogRef
 */
constructor(private _dialogRef: MdDialogRef<TdConfirmDialogComponent>) {}
/**
 * @return {?}
 */
cancel(): void {
    this._dialogRef.close(false);
  }
/**
 * @return {?}
 */
accept(): void {
    this._dialogRef.close(true);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css' ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialogRef, },
];
}

function TdConfirmDialogComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdConfirmDialogComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdConfirmDialogComponent.ctorParameters;
/** @type {?} */
TdConfirmDialogComponent.prototype.title;
/** @type {?} */
TdConfirmDialogComponent.prototype.message;
/** @type {?} */
TdConfirmDialogComponent.prototype.cancelButton;
/** @type {?} */
TdConfirmDialogComponent.prototype.acceptButton;
/** @type {?} */
TdConfirmDialogComponent.prototype._dialogRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
